import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

const HIDE_BREADCRUMBS_PATHS = [
  "/",
  "/login",
  "/register",
  "/forgot-password",
  "/Appointments"
];

const AppBreadcrumbs = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // ❌ Hide breadcrumbs for selected routes
  if (HIDE_BREADCRUMBS_PATHS.includes(location.pathname)) {
    return null;
  }

  const pathnames = location.pathname.split("/").filter(Boolean);

  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  const filteredPaths = pathnames.filter(
    (item) => !uuidRegex.test(item) && isNaN(item)
  );

  const formatLabel = (value) =>
    value
      .split("-")
      .map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(" ");

  return (
    <Breadcrumbs aria-label="breadcrumb">
      <Link
        underline="hover"
        color="inherit"
        sx={{ cursor: "pointer" }}
        onClick={() => navigate("/")}
      >
        Home
      </Link>

      {filteredPaths.map((value, index) => {
        const routeTo =
          "/" + filteredPaths.slice(0, index + 1).join("/");
        const isLast = index === filteredPaths.length - 1;

        return isLast ? (
          <Typography key={index} color="text.primary">
            {formatLabel(value)}
          </Typography>
        ) : (
          <Link
            key={index}
            underline="hover"
            color="inherit"
            sx={{ cursor: "pointer" }}
            onClick={() => navigate(routeTo)}
          >
            {formatLabel(value)}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default AppBreadcrumbs;
